import { render, staticRenderFns } from "./ValidateMedicalTextfield.template.vue?vue&type=template&id=68f16408&scoped=true&"
var script = {}
import style0 from "./ValidateMedicalTextfield.template.vue?vue&type=style&index=0&id=68f16408&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f16408",
  null
  
)

export default component.exports